var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisionSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03",
    "data-name": 3,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_8_eye",
    transform: "translate(520.691 94.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12611",
    "data-name": "Path 12611",
    d: "M34.309,124.089C10.048,124.521,0,141.768,0,141.768s10.048,17.247,34.309,17.679c24.262-.432,34.309-17.679,34.309-17.679s-10.047-17.247-34.309-17.679Z",
    transform: "translate(0 -124.089)",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12612",
    "data-name": "Path 12612",
    d: "M67.386,216.55c.315.463.47.728.47.728s-10.047,17.247-34.309,17.679c-15.357-.273-25.017-7.283-30.04-12.392,2.235,3.283,12.579,16.572,33.839,16.95,24.262-.432,34.309-17.679,34.309-17.679A30.174,30.174,0,0,0,67.386,216.55Z",
    transform: "translate(-3.036 -204.158)",
    fill: "#c4e2ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_372",
    "data-name": "Ellipse 372",
    cx: 17.679,
    cy: 17.679,
    r: 17.679,
    transform: "translate(16.63)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12613",
    "data-name": "Path 12613",
    d: "M192.177,202.054a9.877,9.877,0,1,1,9.877-9.877A9.888,9.888,0,0,1,192.177,202.054Z",
    transform: "translate(-157.868 -174.499)",
    fill: "#465a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12614",
    "data-name": "Path 12614",
    d: "M269.143,185.883a4.778,4.778,0,1,1,4.779-4.778A4.784,4.784,0,0,1,269.143,185.883Z",
    transform: "translate(-228.934 -169.325)",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12615",
    "data-name": "Path 12615",
    d: "M171.861,147.278a17.679,17.679,0,0,1-24.583,24.583,17.679,17.679,0,1,0,24.583-24.583Z",
    transform: "translate(-127.54 -144.17)",
    fill: "#7d84ba"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionSmall);
export default __webpack_public_path__ + "static/media/vision_small.989dd891e047eed8f69aa33e9c86793c.svg";
export { ForwardRef as ReactComponent };